export default __webpack_public_path__ + "static/media/m-lobio.32a48457.png";